import styled from 'styled-components';
import { ButtonGroup, Select } from 'next/components/ui';

export const Form = styled.form`
  margin-top: 12px;

  ${Select} {
    max-width: 100%;
  }

  ${ButtonGroup} {
    margin-top: 24px;
  }
`;

// TemplateOptions

export const OptionWrapper = styled.div`
  display: flex;
  gap: 4px;
`;

export const OptionImage = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 64px;
  height: 72px;
  padding: 4px;
  background: var(--white-walker);
  border-radius: 4px;
`;

export const Image = styled.img`
  width: ${({ size }) => `${size.width}px`};
  height: ${({ size }) => `${size.height}px`};
`;

export const OptionLabelWrapper = styled.div`
  flex-grow: 1;
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding-left: 12px;
`;

export const OptionLabel = styled.div`
  font-weight: var(--bold);
`;

export const SubLabel = styled.div`
  font-size: var(--regular);
`;
